export default __webpack_public_path__ + "static/WellNet-New-Logo_Horizontal-191a7bb6b83b23691079850e5dbb4e53.png";